import { render, staticRenderFns } from "./VaffObjectField.vue?vue&type=template&id=1e42c209&scoped=true&"
import script from "./VaffObjectField.vue?vue&type=script&lang=js&"
export * from "./VaffObjectField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e42c209",
  null
  
)

export default component.exports